import { Block } from 'slate';
import BlockTypes from '../../../types/BlockTypes';
import generateBlockId from '../../utils/generateBlockId';
import getTableRowCountForCells from '../utils/getTableRowCountForCells';
import getTableColumnCountForCells from '../utils/getTableColumnCountForCells';
export default function addTableRow(editor, tableId, newRowIndex) {
  var cells = editor.getTableCells(tableId);
  var table = editor.value.document.getParent(cells.first().key);
  var rowCount = getTableRowCountForCells(cells);
  var columnCount = getTableColumnCountForCells(cells);
  var index = typeof newRowIndex === 'number' ? newRowIndex : rowCount;

  if (index < 0 || index > rowCount) {
    throw new Error('Wrong table row insertion index');
  }

  var firstCellIndex = table.getPath(cells.first().key).last();
  var insertionIndex = firstCellIndex + index * columnCount;
  return editor.withoutNormalizing(function () {
    for (var i = 0; i < columnCount; i++) {
      var _index = insertionIndex + i;

      editor.insertNodeByKey(table.key, _index, Block.create({
        type: BlockTypes.TABLE_CELL,
        data: cells.getIn([i, 'data']).set('id', generateBlockId())
      }));
    }
  });
}